import { hasActiveContractOnDay } from "utils/employeePeriod";

const employeeWithContracts = (employee, contractAssignments) => {
	if (!Array.isArray(contractAssignments)) return employee;
	return {
		...employee,
		employee_contracts: contractAssignments,
	};
};

export function collectEmployeesWithoutContractForDays(
	plan_assignments,
	day_selection,
	contractsByEmployeeId
) {
	const entries = [];
	const seenEmployeeIds = new Set();

	(day_selection || []).forEach((item) => {
		const assignmentRow = plan_assignments?.[item.row];
		const planDay = assignmentRow?.plans?.[item.index];
		const employee = assignmentRow?.employee;

		if (!employee?.id || !planDay?.day) return;

		const contracts = contractsByEmployeeId?.get(employee.id);
		const employeeForDay = employeeWithContracts(employee, contracts);
		if (hasActiveContractOnDay(employeeForDay, planDay.day)) return;
		if (seenEmployeeIds.has(employee.id)) return;

		seenEmployeeIds.add(employee.id);
		entries.push({ employee, day: planDay.day });
	});

	return entries;
}

const asContractList = (response) => {
	if (Array.isArray(response)) return response;
	if (Array.isArray(response?.data)) return response.data;
	return null;
};

/**
 * Revisa los días seleccionados. Si el contrato en curso no cubre alguno,
 * carga el historial de ese empleado y vuelve a comprobar antes de avisar.
 */
export async function resolveEmployeesWithoutContractForDays(
	plan_assignments,
	day_selection,
	loadContracts
) {
	const localMissing = collectEmployeesWithoutContractForDays(
		plan_assignments,
		day_selection
	);
	if (localMissing.length === 0 || typeof loadContracts !== "function") {
		return localMissing;
	}

	const contractsByEmployeeId = new Map();
	await Promise.all(
		localMissing.map(async ({ employee }) => {
			try {
				const contracts = asContractList(await loadContracts(employee.id));
				if (contracts) {
					contractsByEmployeeId.set(employee.id, contracts);
				}
			} catch (error) {
				// Sin historial, se mantiene el aviso con los datos del plan.
			}
		})
	);

	if (contractsByEmployeeId.size === 0) return localMissing;

	return collectEmployeesWithoutContractForDays(
		plan_assignments,
		day_selection,
		contractsByEmployeeId
	);
}

export function isContractNotFoundPlanError(error) {
	if (!error) return false;
	if (error.key === "contract.not_found") return true;
	const description = (error.description || "").toLowerCase();
	return description.includes("contrato") && description.includes("no");
}
